import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { FormGroupUpdateService } from '../../services';
import { ToastResponse } from '../../utilities/ToastResponse';

export const fetchFormGroupUpdate = createAsyncThunk(
    'formGroupUpdate/fetchFormGroupUpdate',
    async ({ id, file, title, slug, description, content, pageId }) => {
        const response = await FormGroupUpdateService(id, file, title, slug, description, content, pageId)
        ToastResponse(response?.data?.statusCode, response?.data?.message)
        return response.result
    }
)

const formGroupUpdateSlice = createSlice({
    name: 'formGroupUpdate',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchFormGroupUpdate.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchFormGroupUpdate.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchFormGroupUpdate.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default formGroupUpdateSlice.reducer;
